import { el, setChildren } from 'redom';

import OutsideClickEventRegistration from 'lib/outside-click-event-registration';

import { displayElementAroundAnchor } from 'utilities/element-position';

class MorePageActionsMenu {

  constructor(configuration) {

    this.menu = null;

    this.anchor = configuration.anchor;
    this.buttons = configuration.buttons;
    this.onClose = configuration.onClose;
    this.verticalOffsetFromAnchor = configuration.verticalOffsetFromAnchor || 0;
    this.horizontalOffsetFromAnchor = configuration.horizontalOffsetFromAnchor || 5;
    this.startSide = configuration.startSide || 'right';

    this.outsideEventRegistration = null;

    this.el = el('.more-actions-menu-wrapper', {
      id: configuration.id || `menu-${performance.now()}`,
      class: configuration.class || ''
    }, [
      this.renderMenu()
    ]);

  }

  onmount() {

    this.outsideEventRegistration = new OutsideClickEventRegistration(this.el, this.outsideClickHandler.bind(this));

    this.positionMenu();

    this.el.focus();

  }

  onunmount() {

    this.outsideEventRegistration.cancel();

  }

  renderMenu() {

    this.menu = el('.more-actions-menu-main', this.buttons);

    return this.menu;

  }

  outsideClickHandler(targetElement, event) {

    this.onClose(event);

  }

  positionMenu() {

    const element = this.el;
    const anchorElement = this.anchor;
    const viewportElement = void 0;
    const verticalOffset = this.verticalOffsetFromAnchor;
    const horizontalOffset = this.horizontalOffsetFromAnchor;
    const startSide = this.startSide;
    const placeOnCenter = true;

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, ['right', 'bottom']);

  }

  update(configuration) {

    this.anchor = configuration.anchor;
    this.onClose = configuration.onClose;

  }

  setButtons(buttons) {

    setChildren(this.menu, buttons);

  }

}

export default MorePageActionsMenu;
